import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import CustomText, { C3Text } from "../../../common/components/text/CustomText";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import React, { useEffect, useState } from "react";
import { Theme } from "../../../common/Theme";
import FranchiseService from "../../../service/FranchiseService";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import Translate from "../../../common/translate/Translate";

export default function FranchiseAddModal({ isOpen, onClose, onSave }) {
    const service = new FranchiseService();
    // state
    const [name, setName] = useState("");
    const [code, setCode] = useState("");

    // button activated
    const [isButtonActivated, setIsButtonActivated] = useState(false);

    // popup
    const [isErrorPopup, setIsErrorPopup] = useState(false);
    const [errorContent, setErrorContent] = useState("프랜차이즈 코드는 영문 대문자 두자리만 허용합니다.");

    useEffect(() => {
        setIsButtonActivated(name.trim() !== "" && code.trim() !== "");
    }, [name, code]);

    const handleSave = async () => {
        if (code.length !== 2) {
            setErrorContent("프랜차이즈 코드는 영문 대문자 두자리만 허용합니다.");
            setIsErrorPopup(true);
            return;
        }

        const isTwoUpperCases = /^[A-Z]{2}$/.test(code);

        if (!isTwoUpperCases) {
            setErrorContent("프랜차이즈 코드는 영문 대문자 두자리만 허용합니다.");
            setIsErrorPopup(true);
            return;
        }

        const reqDto = {
            request: {
                countryCode: localStorage.getItem(LocalStorageKey.server) || "TH",
                franchiseCode: code,
                name: name.trim(),
                timezone: "Asia/Seoul",
                maxTicketNo: 99,
            },
        };

        service
            .saveFranchise(reqDto)
            .then((result) => {
                if (result.resultCode === "9004") {
                    setErrorContent(Translate("popup.duplicateFranchise"));
                    setIsErrorPopup(true);
                } else if (result.resultCode === "0002") {
                    setErrorContent("프랜차이즈 코드 혹은 이름에 사용할 수 없는 문자가 포함되어 있습니다.");
                    setIsErrorPopup(true);
                } else {
                    onSave();
                    onClose();
                }
            })
            .catch((err) => {
                console.log("err", err);
                if (err.resultCode === "0002") {
                    setErrorContent("프랜차이즈 코드 혹은 이름에 사용할 수 없는 문자가 포함되어 있습니다.");
                    setIsErrorPopup(true);
                }
            });
    };

    return (
        <CustomModal
            title={"Add Franchise"}
            isOpen={isOpen}
            onClose={onClose}
            width={"552px"}
            side={"right"}
            height={"90vh"}
            bottomButtons={
                <Row justifyContent={"flex-end"} width={"100%"} padding={"22px 20px"}>
                    <SecondaryButton text={"Cancel"} width={"70px"} padding={"7.75px 14.5px"} onClick={onClose} />
                    <SizedBox width={"10px"} />
                    <PrimaryButton
                        text={"Save"}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={handleSave}
                        disabled={!isButtonActivated}
                    />
                </Row>
            }
        >
            <SizedBox
                backgroundColor={Theme.color.neutral100}
                borderRadius={"16px"}
                width={"100%"}
                height={"auto"}
                padding={"20px"}
                alignItem={"flex-start"}
            >
                <CustomText fontSize={"14px"} fontWeight={"500"} fontColor={Theme.color.gray500}>
                    Franchise Code Guide
                </CustomText>
                <SizedBox height={"10px"} />
                <C3Text fontColor={Theme.color.gray500} fontWeight={"400"} lineHeight={"150%"}>
                    Format: 2 Uppercase letters + 4 Digits (e.g., AA0001).
                </C3Text>
                <C3Text fontColor={Theme.color.gray500} fontWeight={"400"} lineHeight={"150%"}>
                    Sequence: Codes must be entered in sequential order (e.g., AA0001 → AA0002).
                </C3Text>
                <C3Text fontColor={Theme.color.gray500} fontWeight={"400"} lineHeight={"normal"}>
                    Transition: Increment the letter prefix only after the number reaches 9999 (e.g., AA9999 → AB0001
                    ... → ZZ0001).
                </C3Text>
                <SizedBox height={"2px"} />
                <C3Text fontColor={Theme.color.rose500} fontWeight={"400"} lineHeight={"normal"}>
                    Warning: The Franchise Code cannot be modified after saving.
                </C3Text>
            </SizedBox>
            <SizedBox height={"16px"} />
            <SizedBox
                border={`1px solid ${Theme.color.gray200}`}
                borderRadius={"16px"}
                width={"100%"}
                height={"auto"}
                padding={"20px"}
                alignItem={"flex-start"}
            >
                <TitleAndInput
                    title={"Franchise Code"}
                    type={"normal"}
                    placeholder={"Please enter the franchise code"}
                    inputValue={code}
                    setInputValue={setCode}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Franchise Name"}
                    type={"normal"}
                    placeholder={"Please enter the franchise name"}
                    inputValue={name}
                    setInputValue={setName}
                />
            </SizedBox>
            {/* TODO: 번역 확인 필요 */}
            <CustomPopup isOpen={isErrorPopup} onConfirm={() => setIsErrorPopup(false)} message={errorContent} />
        </CustomModal>
    );
}
